
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export interface PageEventStat {
  page: string;
  views: number;
}

interface StatsListCardProps {
  stats: PageEventStat[];
  title: string;
  description: string;
  emptyMessage: string;
  statLabel: string;
}

const StatsListCard = ({ 
  stats, 
  title, 
  description, 
  emptyMessage,
  statLabel 
}: StatsListCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        {stats.length > 0 ? (
          <ul className="space-y-2">
            {stats.map((stat, i) => (
              <li key={i} className="flex justify-between items-center">
                <span className="truncate max-w-[70%]">{stat.page}</span>
                <span className="bg-primary/10 text-primary px-2 py-1 rounded-md text-sm">
                  {stat.views} {statLabel}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted-foreground">{emptyMessage}</p>
        )}
      </CardContent>
    </Card>
  );
};

export default StatsListCard;
